export function byCreatedAtDesc(a, b) {
  if (a.createdAt < b.createdAt) {
    return 1;
  }
  if (b.createdAt < a.createdAt) {
    return -1;
  }
  return 0;
}

export function byUpdatedAtDesc(a, b) {
  if (a.updatedAt < b.updatedAt) {
    return 1;
  }
  if (b.updatedAt < a.updatedAt) {
    return -1;
  }
  return 0;
}
